/** @jsxImportSource @emotion/react */
import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import { Box, Card } from "@mui/material";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const Loader = styled(Box)(({ size = 100, sx }) => ({
  margin: "auto",
  border: (size * 8) / 100 + "px solid #a19f9c",
  borderTop: (size * 8) / 100 + "px solid #4b93f6",
  borderRadius: "50%",
  width: size + "px",
  height: size + "px",
  animation: `${spin} 1.5s ease infinite`,
  ...sx,
}));

export const ControlWidget = styled(Card)`
  z-index: 1;
  position: absolute;
  margin: 8px;

  .MuiCardContent-root:last-child {
    padding-bottom: 16px;
  }
`;

export const SelectWrapper = styled.div`
  width: 100%;
  margin-bottom: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
